import React, { useEffect } from 'react';

import { FaCheck } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { selectShowSuccess } from '../../slices/promoCode';

const Icon = styled(FaCheck)`
  position: absolute;
  top: calc(1em + 20px);
  left: 20px;
  transform: translateY(-50%);
  color: ${props => props.theme.colors.green500};
`;

const IconRenderer = ({ handleResetInput }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      handleResetInput();
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [handleResetInput]);
  return <Icon />;
};

export function PromoCodeSuccessIconRenderer({ handleResetInput }) {
  const shouldShowSuccess = useSelector(selectShowSuccess);
  return !shouldShowSuccess ? null : (
    <IconRenderer handleResetInput={handleResetInput} />
  );
}
